<template>
  <a-tabs centered>
    <a-tab-pane v-for="status in EActivityStatus" :key="status" :tab="DEActivityStatusMap[status]">
      <div class="businesses">
        <a-card bordered
                v-for="b in editor.businesses[status].filter(b => editor.customBusinessRange[status].includes(b.meta.kind))"
                :key="b">
          <template #title>
            <a-flex gap="middle">
              <component :is="b.icon"/>
              <a-flex vertical>
                <a-typography-text strong style="font-size: 16px">{{ b.title }}
                  &nbsp;<a-tooltip :title="b.description">
                    <question-circle-outlined style="color: gray"/>
                  </a-tooltip>
                </a-typography-text>
              </a-flex>
            </a-flex>
          </template>
          <template #extra>
            <a-switch v-model:checked="b.meta.enabled" un-checked-children="关" :disabled="b.meta.lock"
                      checked-children="开" @change="editor.onBizChange(status,b.meta.kind,$event)"/>
          </template>
          <a-flex vertical gap="middle">
            <a-watermark v-if="b.preview" content="效果图" class="water" v-bind="model">
              <img :src="b.preview" alt=""/>
            </a-watermark>
            <a-radio-group v-if="b.implementations(status).length>1" v-model:value="b.meta.implementer"
                           :options="b.implementations(status)" :disabled="!b.meta.enabled"
                           @change="editor.onImplementerChange(status,$event,b.meta)"/>

            <a-checkbox-group v-if="b.subs(status).length > 0" v-model:value="b.meta.subs" :options="b.subs(status)"
                              @change="editor.onBizSubChange(status,$event,b.meta)" :disabled="!b.meta.enabled"
                              style="width: 100%; flex-direction: column; gap: 8px"/>
          </a-flex>
        </a-card>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script setup lang="ts">

import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {DEActivityStatusMap, EActivityStatus} from "@/model/activity";
import {QuestionCircleOutlined} from "@ant-design/icons-vue";
import {reactive} from "vue";

const editor = useRoute().meta.editor as AEditor;
const model = reactive({font: {color: 'rgba(255,255,255,0.7)', fontSize: 28}, gap: [46, 46]})
</script>

<style scoped lang="sass">
.businesses
  column-count: 2
  column-gap: 14px
  padding: 0 18px

  > .ant-card
    break-inside: avoid
    margin-bottom: 14px

  .water
    color: gray

    img
      border-radius: 8px
      width: -webkit-fill-available
</style>